<script>
  // Reactively exposes the header's accessibility-mode toggle (store/modules/ui.js) to any
  // component that needs to show a discoverable scrollbar instead of a hidden one - see
  // .visible-scrollbar / .hide-scrollbar in assets/scss/utils/styleDefault.scss.
  export default {
    computed: {
      accessibilityMode() {
        return this.$store.getters['ui/accessibilityMode']
      },
      scrollbarClass() {
        return this.accessibilityMode ? 'visible-scrollbar' : 'hide-scrollbar'
      },
    },
  }
</script>
